import type { OrganizationSummaryResponse } from "~/types/organizations";
import type {
  SchoolLessonFormData,
  SchoolPdfProcessingStatus,
} from "~/types/content";

export function getSchoolMaterialsAccess(
  organization?: Pick<
    OrganizationSummaryResponse,
    "role" | "permissions"
  > | null,
) {
  const canManage = Boolean(
    organization &&
    (organization.role === "owner" ||
      organization.permissions?.["content.school_materials.manage"] === true),
  );
  return {
    canManage,
    canView:
      canManage ||
      organization?.permissions?.["content.school_materials.view"] === true,
  };
}

export const SCHOOL_PDF_MAX_BYTES = 50 * 1024 * 1024;

export function validateSchoolPdf(
  file: Pick<File, "name" | "type" | "size"> | null,
  required: boolean,
): string {
  if (!file) return required ? "Selecione o PDF da aula." : "";
  if (
    !/\.pdf$/i.test(file.name) ||
    (file.type && file.type !== "application/pdf")
  )
    return "Selecione um arquivo PDF.";
  if (file.size === 0) return "O PDF está vazio. Selecione outro arquivo.";
  if (file.size > SCHOOL_PDF_MAX_BYTES)
    return "O PDF deve ter no máximo 50 MiB.";
  return "";
}

// A replacement never moves the lesson or clears an existing PDF implicitly.
export function buildSchoolLessonFormData(
  values: SchoolLessonFormData,
  bookId?: number,
): FormData {
  const data = new FormData();
  data.append("name", values.name.trim());
  data.append("description", values.description.trim());
  data.append(
    "published",
    String(bookId === undefined ? values.published : false),
  );
  if (bookId !== undefined) data.append("lessonplan", String(bookId));
  if (values.pdf_file) data.append("pdf_file", values.pdf_file);
  return data;
}

export function schoolLessonEditorLocation(lessonId: number, bookId: number) {
  return {
    path: `/lessons/${lessonId}`,
    query: {
      returnTo: `/school-dashboard/materials/${bookId}`,
      workspace: "school",
    },
  };
}

export function schoolPdfStatusLabel(
  status: SchoolPdfProcessingStatus,
): string {
  return {
    pending: "PDF em preparação",
    processing: "PDF em preparação",
    ready: "PDF pronto",
    failed: "PDF original disponível",
  }[status];
}
